import type {
  FaqItem,
  FinalCtaContent,
  GuaranteeContent,
  HeroContent,
  HookContent,
  OfferContent,
  PainContent,
  RevelationContent,
  SalesNotification,
  Testimonial,
  TransformationItem
} from '../types/salesPage'

/** Único enlace de compra real: el botón de la vitrina de la oferta. */
export const CHECKOUT_URL = 'https://rutinasimple.com//cart/53054871994649:1'

/** El resto de los botones llevan al bloque de la oferta, donde está el botón de compra. */
export const OFFER_ANCHOR = '#oferta'

export const urgencyBar = {
  label: 'Oferta de validación',
  text: '92% de descuento disponible solo para los próximos 50 hombres. La libertad no espera.',
  spotsLeft: '50 cupos'
}

export const hero: HeroContent = {
  mast: 'NEURO-PUREZA',
  kicker: 'Ciencia + Fe · Método de 30 días',
  headline: {
    before: 'Cómo Apagar el Deseo por la Pornografía desde la Raíz en 30 Días ',
    accent: 'Sin Usar “Fuerza de Voluntad”',
    after: ' — Incluso Si Has Caído Mil Veces y Sientes que Dios se ha Olvidado de Ti.'
  },
  subheadline:
    'Descubre el método de Neuro-Pureza: el sistema basado en ciencia y fe para re-cablear tu cerebro, recuperar tu matrimonio y vivir con la frente en alto de una vez por todas.',
  proofPoints: [
    'Sin contar rachas de días',
    'Basado en neuroplasticidad',
    'Anclado en Romanos 12:2'
  ],
  ctaLabel: 'QUIERO VER EL MÉTODO',
  ctaNote: 'Acceso inmediato · Garantía de 7 días · Cargo discreto',
  image: {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/4c3efda8-3342-41d2-aa5a-2f375ed63b2d.jpg',
    alt: 'Hombre sentado a solas en una habitación oscura con el rostro iluminado por la pantalla de su teléfono'
  }
}

export const hook: HookContent = {
  eyebrow: '',
  title: '¿Alguna vez has sentido que hay dos personas viviendo dentro de ti?',
  intro:
    'Uno de ellos se levanta el domingo con el corazón encendido. El otro aparece a las 2 a.m. y no reconoce ninguna promesa.',
  panels: [
    {
      label: 'El hombre del domingo',
      title: 'El que ama a Dios, a su familia y sus valores',
      text: 'Ora, sirve, guía y cree cada palabra que dice. Su fe es real y su intención es genuina.',
      image: {
        src: 'https://cdn.magicpatterns.com/patterns/generated-images/0ac918f9-2943-4ac6-a4f6-70d976b5573c.jpg',
        alt: 'Hombres orando en la iglesia con la luz de la mañana entrando por las ventanas'
      }
    },
    {
      label: 'El hombre de las 2 a.m.',
      title: 'El que pierde todo el control frente a una pantalla',
      text: 'Cansado, estresado o solo. En un microsegundo la resolución se apaga y el ciclo vuelve a empezar.',
      image: {
        src: 'https://cdn.magicpatterns.com/patterns/generated-images/4c3efda8-3342-41d2-aa5a-2f375ed63b2d.jpg',
        alt: 'Hombre a solas de madrugada con el rostro iluminado por el brillo azul de una pantalla'
      }
    }
  ],
  closing:
    'Si estás cansado de las rachas de 3 días que terminan en vergüenza, esto es para ti.'
}

export const pain: PainContent = {
  eyebrow: 'Lo que realmente te está costando',
  title: 'La pornografía no solo te quita tiempo; te quita el alma.',
  paragraphs: [
    'Te deja con esa neblina mental y esa náusea interna cada vez que cierras la ventana del navegador.',
    'Has intentado orar más, ayunar más y prometer más… pero el ciclo se repite.'
  ],
  losses: [
    'Te quita la capacidad de mirar a tu esposa a los ojos sin sentirte un fraude.',
    'Te quita la autoridad espiritual para orar con tus hijos.',
    'Te quita la claridad mental para liderar tu casa y tu trabajo.'
  ],
  verdict:
    'No estás peleando contra un pecado: estás peleando contra una arquitectura cerebral secuestrada.',
  image: {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/ca17f03a-494b-417e-8e3c-d5152fad3ea5.jpg',
    alt: 'Mano tachando con marcador negro los días de un calendario de pared'
  }
}

export const revelation: RevelationContent = {
  eyebrow: 'El nuevo mecanismo',
  title: 'La solución no es “esforzarse más”. Es renovar la mente de forma literal.',
  verse: '“Transformaos mediante la renovación de vuestro entendimiento.”',
  verseRef: 'Romanos 12:2',
  paragraphs: [
    'La Neuro-Pureza es el “Nuevo Mecanismo”. En lugar de pelear contra el deseo, aprendes a apagar el interruptor químico que lo genera.',
    'Cuando sanas tus receptores de dopamina, la pornografía deja de ser una tentación irresistible y se convierte en algo… aburrido.'
  ],
  contrast: {
    oldWay: {
      label: 'El viejo camino',
      items: [
        'Contar días y vigilar la tentación',
        'Filtros, promesas y dientes apretados',
        'Vergüenza → cortisol → recaída'
      ]
    },
    newWay: {
      label: 'Neuro-Pureza',
      items: [
        'Sanar los receptores de dopamina',
        'Reactivar el lóbulo frontal',
        'El deseo se apaga desde la raíz'
      ]
    }
  },
  image: {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/0898137d-83fc-4474-8723-c54f507a7489.jpg',
    alt: 'Modelo anatómico de un cerebro humano con el lóbulo frontal iluminado en ámbar'
  }
}

export const offer: OfferContent = {
  eyebrow: 'El sistema completo',
  title: 'Presentamos el Sistema ',
  titleAccent: 'NEURO-PUREZA',
  subtitle: 'El mapa completo para el hombre que quiere libertad real, no solo una racha de días.',
  mainItem: {
    tag: 'Ebook Principal',
    name: 'Neuro-Pureza',
    description: 'El método paso a paso de Neuro-Teología.',
    value: '$97',
    image: {
      src: 'https://cdn.magicpatterns.com/uploads/652ziy7USNbyEK3dYduzRc/mockup_ebook.png',
      alt: 'Portada del ebook Neuro-Pureza'
    }
  },
  bonuses: [
    {
      tag: 'Bono 01',
      name: 'El Interruptor de Dopamina',
      description: 'Detén el impulso en 30 segundos.',
      value: '$27',
      image: {
        src: 'https://cdn.magicpatterns.com/uploads/d3oxENhgXN3PSE6t5YBzpJ/Bono-1.png',
        alt: 'Portada de la guía El Interruptor de Dopamina'
      }
    },
    {
      tag: 'Bono 02',
      name: 'Devocional 21 Días',
      description: 'Recupera tu identidad de hijo.',
      value: '$37',
      image: {
        src: 'https://cdn.magicpatterns.com/uploads/2YDJjSttAZa5wXTCKj2q2d/Bono-2.png',
        alt: 'Portada del devocional Nueva Identidad: 21 Días'
      }
    },
    {
      tag: 'Bono 03',
      name: 'Manual Matrimonial',
      description: 'Reconstruye la confianza con ella.',
      value: '$47',
      image: {
        src: 'https://cdn.magicpatterns.com/uploads/9ECsmfaa4Zzxhkzq64qErF/Bono-3.png',
        alt: 'Portada del manual Restauración Matrimonial'
      }
    },
    {
      tag: 'Bono 04',
      name: 'Bio-Hacking',
      description: 'Nutrición y sueño para una voluntad de hierro.',
      value: '$27',
      image: {
        src: 'https://cdn.magicpatterns.com/uploads/a7rdVG3jKriqdpX3R2JbE7/Bono-4.png',
        alt: 'Portada de la guía Bio-Hacking para la Pureza'
      }
    },
    {
      tag: 'Bono 05',
      name: 'Protocolo Solteros',
      description: 'Navega el mundo real con integridad.',
      value: '$37',
      image: {
        src: 'https://cdn.magicpatterns.com/uploads/sXVxuxRv5RT6pw1HCx3ENH/Bono-5.png',
        alt: 'Portada del Protocolo para Solteros'
      }
    }
  ],
  totalLabel: 'Valor total',
  totalValue: '$272',
  priceLabel: 'Hoy por solo',
  price: '$19.99',
  ctaLabel: 'SÍ, QUIERO APAGAR EL DESEO Y RECUPERAR MI VIDA — ACCESO INMEDIATO POR $19.99',
  microcopy: ['Garantía de Libertad de 7 Días', 'Cargo discreto en tu tarjeta']
}

export const transformation: TransformationItem[] = [
  {
    title: 'Tu identidad',
    text: 'Despiertas sin la resaca mental de la noche anterior y vuelves a mirar de frente.',
    image: {
      src: 'https://cdn.magicpatterns.com/patterns/generated-images/2ff31771-68de-4828-b26b-d30f9102c831.jpg',
      alt: 'Hombre de pie frente a una ventana al amanecer con luz dorada en el rostro'
    }
  },
  {
    title: 'Tu matrimonio',
    text: 'La confianza se reconstruye cuando ella deja de sentir que compite con una pantalla.',
    image: {
      src: 'https://cdn.magicpatterns.com/patterns/generated-images/dd650180-e4a9-4609-a2eb-01901b65da32.jpg',
      alt: 'Esposo y esposa juntos junto a una ventana con luz cálida al atardecer'
    }
  },
  {
    title: 'Tu autoridad',
    text: 'Vuelves a orar con tus hijos y a liderar a otros hombres sin sentirte un fraude.',
    image: {
      src: 'https://cdn.magicpatterns.com/patterns/generated-images/b5b5421f-6ff3-4244-a269-02ccfa69aa99.jpg',
      alt: 'Grupo de hombres conversando en círculo bajo una luz cálida'
    }
  }
]

export const liveViewers = {
  baseCount: 187,
  label: 'hombres viendo esto ahora',
  note: 'Actividad en tiempo real'
}

export const salesNotificationProduct = 'el Sistema Neuro-Pureza'

export const salesNotifications: SalesNotification[] = [
  { name: 'Andrés M.', initials: 'AM', city: 'Bogotá', timeAgo: 'Hace 2 minutos' },
  { name: 'Josué R.', initials: 'JR', city: 'Monterrey', timeAgo: 'Hace 6 minutos' },
  { name: 'Daniel C.', initials: 'DC', city: 'Medellín', timeAgo: 'Hace 9 minutos' },
  { name: 'Iván P.', initials: 'IP', city: 'Santiago', timeAgo: 'Hace 14 minutos' },
  { name: 'Mateo G.', initials: 'MG', city: 'Guadalajara', timeAgo: 'Hace 18 minutos' },
  { name: 'Roberto S.', initials: 'RS', city: 'Lima', timeAgo: 'Hace 23 minutos' },
  { name: 'Felipe A.', initials: 'FA', city: 'Quito', timeAgo: 'Hace 27 minutos' },
  { name: 'Sergio L.', initials: 'SL', city: 'Buenos Aires', timeAgo: 'Hace 34 minutos' }
]

export const socialProof = {
  title: 'Hombres que ya apagaron el interruptor',
  subtitle:
    'Testimonios de hombres reales que aplicaron el protocolo. Publicados con su permiso y solo con inicial de apellido para proteger su privacidad.',
  stats: [
    { value: '3.400+', label: 'Hombres dentro' },
    { value: '4.8/5', label: 'Valoración media' },
    { value: '30 días', label: 'Protocolo completo' }
  ]
}

export const testimonials: Testimonial[] = [
  {
    quote:
      'Llevaba 12 años intentando con filtros, ayunos y contadores. En la segunda semana entendí que no estaba peleando con mi fe, sino con mi química. Es la primera vez que no tengo que “aguantar”.',
    name: 'Andrés M.',
    initials: 'AM',
    detail: 'Casado, 38 años · Bogotá',
    badge: 'Día 30'
  },
  {
    quote:
      'El interruptor de dopamina me salvó tres noches seguidas. Treinta segundos y el impulso pasaba. Nunca había tenido una herramienta concreta para ese momento exacto.',
    name: 'Josué R.',
    initials: 'JR',
    detail: 'Soltero, 26 años · Monterrey',
    badge: 'Día 14'
  },
  {
    quote:
      'Volví a orar con mis hijos sin sentirme un fraude. Eso solo ya valía cien veces lo que pagué.',
    name: 'Daniel C.',
    initials: 'DC',
    detail: 'Casado, 41 años · Medellín',
    badge: 'Día 30'
  },
  {
    quote:
      'Mi esposa notó el cambio antes que yo. Dejé de estar ausente. El manual matrimonial nos dio las palabras que no teníamos para hablarlo.',
    name: 'Iván P.',
    initials: 'IP',
    detail: 'Casado, 35 años · Santiago',
    badge: 'Día 21'
  },
  {
    quote:
      'Pensé que a mi edad ya no había vuelta atrás. Lo de la neuroplasticidad no era discurso: la neblina mental se fue en la tercera semana.',
    name: 'Roberto S.',
    initials: 'RS',
    detail: 'Casado, 52 años · Lima',
    badge: 'Día 30'
  },
  {
    quote:
      'Soy soltero y creía que esto era solo para casados. El protocolo para solteros me dio un plan real para el día a día, no solo “no mires”.',
    name: 'Mateo G.',
    initials: 'MG',
    detail: 'Soltero, 23 años · Guadalajara',
    badge: 'Día 21'
  },
  {
    quote:
      'Lo que más me impactó fue dejar de contar días. Sin el contador encima, la tentación perdió su lugar en mi cabeza.',
    name: 'Felipe A.',
    initials: 'FA',
    detail: 'Casado, 33 años · Quito',
    badge: 'Día 30'
  },
  {
    quote:
      'Volví a dormir bien y a entrenar. El módulo de bio-hacking explica por qué la voluntad se cae cuando el cuerpo está en déficit.',
    name: 'Sergio L.',
    initials: 'SL',
    detail: 'Casado, 29 años · Buenos Aires',
    badge: 'Día 14'
  }
]

export const faqs: FaqItem[] = [
  {
    question: '¿Es esto discreto?',
    answer:
      'Absolutamente. El cargo en tu tarjeta aparecerá como “NP DIGITAL” o similar. Nadie sabrá qué has comprado.'
  },
  {
    question: '¿Funciona si he sido adicto por años?',
    answer:
      'Sí. El cerebro es neuroplástico. No importa cuánto tiempo hayas estado en el hoyo, los circuitos se pueden reconstruir.'
  },
  {
    question: '¿Es solo para casados?',
    answer: 'No, incluimos un protocolo específico para solteros.'
  }
]

export const guarantee: GuaranteeContent = {
  eyebrow: 'Sin riesgo para ti',
  title: 'Garantía de Libertad de 7 Días',
  paragraphs: [
    'Si en una semana no sientes que este método te da más control que cualquier cosa que hayas intentado antes, te devuelvo tus $19.99. Sin preguntas.',
    'Me quedo con el riesgo, tú quédate con la libertad.'
  ],
  seal: '7 días'
}

export const finalCta: FinalCtaContent = {
  title: 'La libertad no espera a que tengas más fuerza de voluntad.',
  paragraphs: [
    'Puedes seguir contando días y reiniciando el contador, o puedes re-cablear el sistema que dispara el deseo.'
  ],
  ctaLabel: 'SÍ, QUIERO APAGAR EL DESEO Y RECUPERAR MI VIDA — ACCESO INMEDIATO POR $19.99',
  microcopy: ['Acceso inmediato', 'Garantía de 7 días', 'Cargo discreto: NP DIGITAL']
}

export const salesStickyBar = {
  label: 'Sistema Neuro-Pureza',
  hint: 'Valor $272 · Hoy $19.99',
  buttonLabel: 'QUIERO ACCESO'
}
